import React, { FC, ReactNode } from 'react';
import { Field } from 'redux-form';
import { useSelector } from 'react-redux';
import { SelectProps } from 'antd/lib/select';
import { getSubjectSelectOptions } from 'logic/store/subject/subject.selectors';
import { FormSelectInput } from 'components/form-inputs/form-select-input/form-select-input';
import { SubjectSelectOption } from 'logic/store/subject/subject.model';

interface FormFieldSubjectProp {
  name: string;
  label?: ReactNode;
  mode?: SelectProps<any>['mode'];
  additionalAntFormItemStyles?: any;
  className?: string;
  placeholder?: string;
  subjectOptions?: SubjectSelectOption[];
}

export const FormFieldSubject: FC<FormFieldSubjectProp> = ({
  name,
  label,
  mode,
  additionalAntFormItemStyles,
  className,
  placeholder,
  subjectOptions,
}) => {
  const storeSubjectOptions = useSelector(getSubjectSelectOptions);

  return (
    <Field
      name={name}
      additionalAntFormItemStyles={additionalAntFormItemStyles}
      component={FormSelectInput}
      options={subjectOptions || storeSubjectOptions}
      showSearch
      filterOption={true}
      optionFilterProp={'label'}
      mode={mode}
      label={label}
      className={className}
      placeholder={placeholder}
    />
  );
};
